import {
  createWelcomeDelivery2ScreenModel,
  type WelcomeDelivery2Props,
} from './WelcomeDelivery2ModelScreen';
import { WelcomeDelivery2Controller } from './WelcomeDelivery2Controller';
import { WelcomeDelivery2View } from './WelcomeDelivery2View';

export type { WelcomeDelivery2Props } from './WelcomeDelivery2ModelScreen';

export function WelcomeDelivery2(props: WelcomeDelivery2Props = {}) {
  const model = createWelcomeDelivery2ScreenModel(props);
  const controller = new WelcomeDelivery2Controller(model);

  return <WelcomeDelivery2View model={model} controller={controller} />;
}
